import { graphql, useLazyLoadQuery } from "react-relay"
import { useDoc2URecipientsQuery as UseDoc2URecipientsQueryType } from "@/modules/patients/detail/progress-note/doc2u/services/__generated__/useDoc2URecipientsQuery.graphql"

const doc2URecipientsQuery = graphql`
  query useDoc2URecipientsQuery {
    ch_doc2URecipients {
      userName
      email
    }
  }
`

export const useDoc2URecipientsQuery = () => {
  return useLazyLoadQuery<UseDoc2URecipientsQueryType>(doc2URecipientsQuery, {})
}
